(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const drawer      = document.getElementById('CartDrawer');
  const closeEls    = drawer ? drawer.querySelectorAll('[data-cart-close]') : [];
  const drawerBody  = document.getElementById('CartDrawerBody');

  const openDrawer = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  document.addEventListener('cart:open', openDrawer);
  closeEls.forEach(el => el.addEventListener('click', closeDrawer));

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Quantity change & remove via Shopify Cart API
  const updateCart = async (updates) => {
    const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (res.ok) location.reload();
  };

  if (drawer) {
    drawer.addEventListener('click', e => {
      const qtyBtn = e.target.closest('[data-qty-change]');
      const removeBtn = e.target.closest('[data-remove-item]');

      if (qtyBtn) {
        const key = qtyBtn.dataset.qtyChange;
        const delta = parseInt(qtyBtn.dataset.delta, 10);
        const qtyEl = qtyBtn.closest('.cart-drawer__qty').querySelector('.cart-drawer__qty-value');
        const current = parseInt(qtyEl.textContent, 10);
        const next = Math.max(0, current + delta);
        updateCart({ [key]: next });
      }

      if (removeBtn) {
        updateCart({ [removeBtn.dataset.removeItem]: 0 });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
